/**
 * components/layout/SoftphoneProvider.tsx
 * Envoltorio compartido entre AppShell (todo el CRM) y WorkspacePage
 * (/workspace, ruta hermana FUERA de AppShell) — evita duplicar el ciclo de
 * vida del softphone y el manejo de modo compacto en dos lugares.
 */
import { useEffect, useState, Suspense, lazy, type ReactNode } from 'react'
import { useAuthStore } from '@/stores/auth.store'
import { useSoftphoneLifecycle } from '@/lib/softphone'
import { subscribeDesktopCompactMode } from '@/lib/desktop'

const CompactCallBar = lazy(() =>
  import('@/components/layout/CompactCallBar').then((m) => ({ default: m.CompactCallBar })),
)

export function SoftphoneProvider({ children }: { children: ReactNode }) {
  const userId = useAuthStore((s) => s.user?.id ?? null)
  const extension = useAuthStore((s) => s.profile?.sip_extension ?? null)
  const [compact, setCompact] = useState(false)

  useSoftphoneLifecycle(userId, extension)
  useEffect(() => subscribeDesktopCompactMode(setCompact), [])

  if (compact) {
    return (
      <Suspense fallback={null}>
        <CompactCallBar />
      </Suspense>
    )
  }

  return <>{children}</>
}
